import PropTypes from 'prop-types';

import SignupPromoTermsModal from 'features/site/SignupPromoTermsModal';
import NanoBanner from 'honeydew/NanoBanner';

function SignupNanoBanner({ discountCodeInfo, setShowPromoTermsModal, showPromoTermsModal }) {
    return (
        <>
            <SignupPromoTermsModal
                showPromoTermsModal={showPromoTermsModal}
                setShowPromoTermsModal={setShowPromoTermsModal}
                termsAndConditions={discountCodeInfo?.nanobarTerms}
            />
            {discountCodeInfo && (
                <NanoBanner
                    boldCopy={discountCodeInfo?.nanobarText}
                    link="Learn more"
                    onClick={() => setShowPromoTermsModal(true)}
                    modalContent={discountCodeInfo?.nanobarTerms}
                    signupBanner
                />
            )}
        </>
    );
}

SignupNanoBanner.propTypes = {
    discountCodeInfo: PropTypes.shape({
        nanobarTerms: PropTypes.string,
        nanobarText: PropTypes.string,
    }),
    setShowPromoTermsModal: PropTypes.func.isRequired,
    showPromoTermsModal: PropTypes.bool.isRequired,
};

SignupNanoBanner.defaultProps = {
    discountCodeInfo: undefined,
};

export default SignupNanoBanner;
